'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Base = require('../Base/Base');

var _Base2 = _interopRequireDefault(_Base);

var _Icon = require('../Icon/Icon');

var _Icon2 = _interopRequireDefault(_Icon);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

require('./Chip.css');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Chip = function (_Component) {
  _inherits(Chip, _Component);

  function Chip() {
    _classCallCheck(this, Chip);

    return _possibleConstructorReturn(this, (Chip.__proto__ || Object.getPrototypeOf(Chip)).apply(this, arguments));
  }

  _createClass(Chip, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          active = _props.active,
          children = _props.children,
          disabled = _props.disabled,
          leftIcon = _props.leftIcon,
          metric = _props.metric,
          rightIcon = _props.rightIcon,
          size = _props.size,
          rest = _objectWithoutProperties(_props, ['active', 'children', 'disabled', 'leftIcon', 'metric', 'rightIcon', 'size']);

      var classes = (0, _classnames2.default)('ax-chip', 'ax-chip--' + size, { 'ax-chip--active': active });

      var metricClasses = (0, _classnames2.default)('ax-chip-metric', { 'ax-chip-metric--light': active });

      return _react2.default.createElement(
        _Base2.default,
        _extends({ className: classes, disabled: disabled }, rest),
        leftIcon && _react2.default.createElement(_Icon2.default, { className: 'ax-chip-icon', name: leftIcon }),
        _react2.default.createElement(
          _Base2.default,
          { className: 'ax-chip-label' },
          children
        ),
        metric && _react2.default.createElement(
          _Base2.default,
          { className: metricClasses },
          ' ',
          metric
        ),
        rightIcon && _react2.default.createElement(_Icon2.default, { className: 'ax-chip-icon', name: rightIcon })
      );
    }
  }]);

  return Chip;
}(_react.Component);

Chip.propTypes = {
  /** Apply active styling */
  active: _propTypes2.default.bool,
  /** Content for chip */
  children: _propTypes2.default.node.isRequired,
  /** Disable interaction behaviour */
  disabled: _propTypes2.default.bool,
  /** Name of the Icon located to the left of the main content */
  leftIcon: _propTypes2.default.string,
  /** Metric content */
  metric: _propTypes2.default.string,
  /** Name of the Icon located to the right of the main content or metric */
  rightIcon: _propTypes2.default.string,
  /** Size of the chip */
  size: _propTypes2.default.oneOf(['small', 'medium', 'large', 'huge'])
};
Chip.defaultProps = {
  size: 'medium'
};
exports.default = Chip;